import { Injectable } from '@angular/core';

import { EnvironmentService } from './environment.service'

@Injectable()
export class ConfigService {

  config: Object = {
    'client': {
      version: '0.0.66'
    },
    'endpoints': {
      public: {
        domain: {
          details: {
            api: '/solar/public/domain',
            method: 'GET',
            parameter: false
          }
        },
        registration: {
          validateUsername: {
            api: '/solar/email/validate',
            method: 'GET',
            parameter: true
          },
          vallidate: {
            api: '/solar/public/registration',
            method: 'GET',
            parameter: false
          },
          register: {
            api: '/solar/public/registration',
            method: 'POST',
            parameter: false
          },
          selfregister: {
            api: '/solar/public/selfregistration',
            method: 'POST',
            parameter: false
          },
          redeemVoucher: {
            api: '/solar/public/voucher/redeem',
            method: 'POST',
            parameter: false
          }
        },
        registrationWithVoucher: {
          vallidate: {
            api: '/solar/public/registration-with-voucher',
            method: 'GET',
            parameter: false
          },
          register: {
            api: '/solar/public/registration-with-voucher',
            method: 'POST',
            parameter: false
          }
        },
        password: {
          remind: {
            api: '/solar/public/password/remind',
            method: 'POST',
            parameter: false
          },
          reset: {
            api: '/solar/public/password/reset',
            method: 'POST',
            parameter: false
          }
        },
        support: {
          create: {
            api: '/solar/public/support/add',
            method: 'POST',
            parameter: false
          }
        }
      },
      solar: {
        review: {
          create: {
            api: '/solar/branded/review/create',
            method: 'POST',
            parameter: false
          }
        },
        class: {
          assignment: {
            list: {
              api: '/solar/branded/license/course/assignment',
              method: 'GET',
              parameter: true
            }
          },
          updatedAssignment: {
            list: {
              api: '/solar/branded/license/course/updated/assignment',
              method: 'GET',
              parameter: true
            }
          },
        },
        upload: {
          presigned: {
            api: '/solar/branded/upload/presigned',
            method: 'POST',
            parameter: false
          },
          complete: {
            api: '/solar/branded/upload/complete',
            method: 'POST',
            parameter: true
          }
        },
        license: {
          list: {
            api: '/solar/branded/license/course',
            method: 'GET',
            parameter: false
          },
          updatedList: {
            api: '/solar/branded/license/updated/course',
            method: 'GET',
            parameter: false
          },
          redeem: {
            api: '/solar/branded/license/redeem',
            method: 'POST',
            parameter: false
          }
        },
        content: {
          markComplete: {
            api: '/domain/api/solar/branded/license/content/mark/completed',
            method: 'POST',
            parameter: true
          },
          list: {
            api: '/solar/branded/license/content',
            method: 'GET',
            parameter: false
          },
          verifyContent: {
            api: '/solar/branded/license/content/verify',
            method: 'GET',
            parameter: false
          },
          verifyContentBulk: {
            api: '/solar/branded/license/content/bulk/verify',
            method: 'GET',
            parameter: false
          },
          updateContent: {
            api: '/solar/branded/license/content/update',
            method: 'GET',
            parameter: false
          },
          details: {
            api: '/solar/branded/license/content/details',
            method: 'GET',
            parameter: true
          },
          read: {
            api: '/solar/branded/license/content/read',
            method: 'GET',
            parameter: true
          }
        },
        evaluation: {
          list: {
            api: '/solar/branded/evaluation',
            method: 'GET',
            parameter: false
          },
          multiContent: {
            api: '/solar/branded/evaluation/newbp',
            method: 'GET',
            parameter: false
          },
          scorm: {
            api: '/solar/branded/evaluation/scorm',
            method: 'GET',
            parameter: false
          },
          ebook: {
            api: '/solar/branded/evaluation/ebook',
            method: 'GET',
            parameter: false
          },
          archive: {
            api: '/solar/branded/evaluation/archive',
            method: 'GET',
            parameter: false
          },
          ispring: {
            api: '/solar/branded/evaluation/spring',
            method: 'GET',
            parameter: false
          },
          deliverableStatus: {
            api: '/solar/branded/evaluation/status',
            method: 'GET',
            parameter: true
          },
          video: {
            api: '/solar/branded/evaluation/video',
            method: 'GET',
            parameter: false
          },
          presentation: {
            api: '/solar/branded/presentation/fileurl',
            method: 'GET',
            parameter: false
          },
        },
        certificates: {
          preview: {
            api: '/solar/branded/certificate/templates/preview',
            method: 'POST',
            parameter: true
          },
          download: {
            api: '/solar/branded/certificate/download',
            method: 'POST',
            parameter: true
          },
          list: {
            api: '/solar/branded/certificate/list',
            method: 'GET',
            parameter: false
          },
          listElearning: {
            api: '/solar/branded/certificate/elearning/certificates',
            method: 'GET',
            parameter: false
          },
          previewElearning: {
            api: '/solar/branded/certificate/elearning/preview',
            method: 'GET',
            parameter: false
          },
          downloadElearning: {
            api: '/solar/branded/certificate/elearning/download',
            method: 'GET',
            parameter: false
          },
          downloadExam: {
            api: '/exam/certificates/downloadlink',
            method: 'GET',
            parameter: false
          }
        },
        deliverable: {
          read: {
            api: '/solar/branded/license/content/deliverable',
            method: 'GET',
            parameter: true
          },
          token: {
            api: '/solar/branded/license/partial-data',
            method: 'GET',
            parameter: true
          },
          updateRegistrationId: {
            api: '/solar/branded/license/update-partial-data',
            method: 'POST',
            parameter: false
          },
          evaluation: {
            token: {
              api: '/solar/branded/license/evaluation/partial-data',
              method: 'GET',
              parameter: true
            },
            updateRegistrationId: {
              api: '/solar/branded/license/evaluation/update-partial-data',
              method: 'POST',
              parameter: false
            }
          }
        },
        scorm: {
          imsmanifest: {
            api: '/solar/branded/scorm/imsmanifest',
            method: 'GET',
            parameter: false
          },
          tracking: {
            api: '/solar/branded/scorm/tracking',
            method: 'GET POST',
            parameter: true
          },
          trackingPages: {
            api: '/solar/branded/scorm/tracking/totalPages',
            method: 'POST',
            parameter: true
          }
        },
        ebook: {
          fileurl: {
            api: '/solar/branded/ebook/fileurl',
            method: 'GET',
            parameter: false
          }
        },
        archive: {
          fileurl: {
            api: '/solar/branded/archive/fileurl',
            method: 'GET',
            parameter: false
          }
        },
        ispring: {
          fileurl: {
            api: '/solar/branded/ispring/fileurl',
            method: 'GET',
            parameter: false
          }
        },
        externalContent: {
          fileurl: {
            api: '/solar/branded/external/fileurl',
            method: 'GET',
            parameter: false
          }
        },
        support: {
          create: {
            api: '/solar/branded/support/add',
            method: 'POST',
            parameter: false
          }
        },
        profile: {
          details: {
            api: '/solar/branded/profile',
            method: 'GET',
            parameter: false
          },
          edit: {
            api: '/solar/branded/profile/update',
            method: 'POST',
            parameter: false
          },
          requestDataDeletion: {
            api: '/solar/branded/profile/requestdatadeletion',
            method: 'POST',
            parameter: false
          },
          updateGdprConsent: {
            api: '/solar/branded/profile/gdpr-consent',
            method: 'POST',
            parameter: false
          }
        },
        system: {
          language: {
            api: '/solar/system/language',
            method: 'GET',
            parameter: false
          },
          timezone: {
            api: '/solar/system/datetime/timezones',
            method: 'GET',
            parameter: false
          }
        },
        video: {
          fileurl: {
            api: '/solar/branded/video/fileurl',
            method: 'GET',
            parameter: false
          }
        },
        catalog: {
          products: {
            api: '/domain/api/solar/consumption/variants/list',
            method: 'GET',
            parameter: false
          },
          productAssignment: {
            api: '/domain/api/solar/consumption/assignment',
            method: 'GET',
            parameter: true
          },
          events: {
            list: {
              api: '/domain/api/solar/branded/event/list',
              method: 'GET',
              parameter: true
            },
            join: {
              api: '/domain/api/solar/branded/license/event/selfregistration',
              method: 'POST',
              parameter: true
            }
          }
        }
      },
      voucherSystem: {
        catalog: {
          productSkus: {
            api: '/domain/api/voucher/v2/consumption/products',
            method: 'GET',
            parameter: false
          }
        }
      },
      hamlet: {
        detailsBySearchKey: {
          api: '/hamlet/support-article/details/search-key',
          method: 'GET',
          parameter: true
        }
      },
      amber: {
        isRegistered: {
          api: '/forgotPassword',
          method: 'GET',
          parameter: true
        }
      },
      zephyr: {
        launchUrl: {
          api: '/zephyr/registration-service',
          method: 'GET',
          parameter: true
        },
        results: {
          api: '/zephyr/registrations/results',
          method: 'GET',
          parameter: true
        },
        evaluation: {
          courses: {
            import: {
              api: '/zephyr/evaluation/course',
              method: 'POST',
              parameter: false
            }
          }
        },
        courses: {
          details: {
            api: '/zephyr/courses',
            method: 'GET',
            parameter: true
          },
          import: {
            api: '/zephyr/course',
            method: 'POST',
            parameter: false
          },
          result: {
            api: '/zephyr/course/import-results',
            method: 'GET',
            parameter: true
          }
        },
        registration: {
          api: '/zephyr/registration',
          method: 'GET',
          parameter: true
        },
        createRegistration: {
          api: '/zephyr/registration',
          method: 'POST',
          parameter: false
        }
      },
      sphinx: {
        download: {
          api: '/proxy',
          method: 'GET',
          parameter: true
        }
      }
    },
    'routes': {
      /** -------------------------SAHARA---------------------------- */
      sahara: {
        storeFileDetails: '/api/file/store-details',
        signature: '/api/file/signature',
        complete: '/api/file/complete'
      },

      /** -------------------------MODULES---------------------------- */

      library: {
        //  Content
        listContent: '/api/library/content',
        contentDetails: '/api/library/content/details', //  :id
        addContent: '/api/library/content/add',

        //  Configurations
        listConfigurations: '/api/library/config',
        configurationDetails: '/api/library/config/details', //  :id
        addConfiguration: '/api/library/config/add',
        editConfiguration: '/api/library/config/update',

        //  Deliverables
        listDeliverables: '/api/library/deliverable',
        deliverableDetails: '/api/library/deliverable/details', //  :id
        addDeliverable: '/api/library/deliverable/add',
        addDeliverableContent: '/api/library/deliverable/content',

        //  Print Specifications
        listPrintSpecifications: '/api/library/printspecification',
        printSpecificationDetails: '/api/library/printspecification/details', //:id
        addPrintSpecification: '/api/library/printspecification/add',

        //  Product Content
        addProductContent: '/api/library/productcontent/add',
        productContentDetails: '/api/library/productcontent/details', //:id
        listProductContent: '/api/library/productcontent',
        addProductContentDeliverable: '/api/library/productcontent/deliverable',

        //  Dictionaries
        getContentTypeDict: '/api/library/config/type/contenttype',
        getStatusDict: '/api/library/config/type/status',
        getLanguageDict: '/api/library/config/type/language',
        getBrandingLevelDict: '/api/library/config/type/brandlevel',
        getCoverTypeDict: '/api/library/config/type/covertype',
        getOrientationDict: '/api/library/config/type/orientation',
        getBindingDict: '/api/library/config/type/binding',
        getPaperTypeDict: '/api/library/config/type/papertype',
        getProductVariantDict: '/api/library/config/type/productvariant',
        getPrintSpecificationDict: '/api/library/printspecs',
        getContentDict: '/api/library/content/dictionary',
        getConfigurationTypeDict: '/api/library/config/type/types',
        getDeliverableDict: '/api/library/deliverable/dictionary',
        getProductContentDeliverables: '/api/library/productcontent/deliverables',
        getDeliverableContent: '/api/library/deliverable/contentlist'
      },

      delivery: {
        listOrders: '/api/delivery/orders',
        orderDetails: '/api/delivery/order/details', //  :id
        orderLogs: '/api/delivery/order/log', //  :id

        listRules: '/api/delivery/rules',
        ruleDetails: '/api/delivery/rule/details', //  :id
        editRule: '/api/delivery/rule/edit',
        addRule: '/api/delivery/rule/add',

        listEmailTemplates: '/api/delivery/emailtemplates',
        emailTemplateDetails: '/api/delivery/emailtemplate/details', //  :id
        editEmailTemplate: '/api/delivery/emailtemplate/edit',
        addEmailTemplate: '/api/delivery/emailtemplate/add',

        //  Configurations
        listConfigurations: '/api/delivery/config',
        configurationDetails: '/api/delivery/config/details', //  :id
        editConfiguration: '/api/delivery/config/edit',
        addConfiguration: '/api/delivery/config/add',

        getTypeDict: '/api/delivery/config/dictionary/types',
        getActionDict: '/api/delivery/config/dictionary/action',
        getOperatorDict: '/api/delivery/config/dictionary/operator',
        getSelectionDict: '/api/delivery/config/dictionary/selection'
      },

      /** -------------------------AMBER---------------------------- */

      //  Users
      listUsers: '/users',
      userDetails: '/users/', //:id
      editUser: '/users/', //:id
      toggleStatusUser: '/users/togglestatus/', //:id
      deleteUser: '/users/delete/', //:id
      addUser: '/users',

      //  Groups
      listGroups: '/groups',
      groupDetails: '/groups/', //:id
      editGroup: '/groups/', //:id
      toggleStatusGroup: '/groups/togglestatus/', //:id
      deleteGroup: '/groups/delete/', //:id
      addGroup: '/groups',

      //  Policies
      listPolicies: '/policies',
      policyDetails: '/policies/', //:id
      editPolicy: '/policies/', //:id
      deletePolicy: '/policies/delete/', //:id
      addPolicy: '/policies',
      listPolicyAPIs: '/policies/apilist',

      //  Profile
      profileDetails: '/profile',
      editProfile: '/profile',

      //  Amber APIs
      listAmberAPIs: '/interfaces',
      amberAPIDetails: '/interfaces/', //:id
      editAmberAPI: '/interfaces/', //:id
      toggleStatusAmberAPI: '/interfaces/togglestatus/', //:id
      deleteAmberAPI: '/interfaces/delete/', //:id
      addAmberAPI: '/interfaces',

      //  Amber Clients
      listAmberClients: '/clients',
      amberClientDetails: '/clients/', //:id
      editAmberClient: '/clients/', //:id
      toggleStatusAmberClient: '/clients/togglestatus/', //:id
      deleteAmberClient: '/clients/delete/', //:id
      addAmberClient: '/clients',

      //  Amber system
      listSystems: '/systems',
      systemDetails: '/systems/', //:id
      editSystem: '/systems/', //:id
      toggleStatusSystem: '/systems/togglestatus/', //:id
      deleteSystem: '/systems/delete/', //:id
      checkHealth: '/systems/check/', //:id
      addSystem: '/systems',

      //  Configurations
      listConfigurations: '/configurations',
      configurationDetails: '/configurations/', //:id
      editConfiguration: '/configurations/', //:id
      toggleStatusConfiguration: '/configurations/togglestatus/', //:id
      addConfiguration: '/configurations',

      //  Connectors
      listConnectors: '/connectors',
      connectorDetails: '/connectors/', //:id
      editConnector: '/connectors/', //:id
      toggleStatusConnector: '/connectors/togglestatus/', //:id
      deleteConnector: '/connectors/delete/', //:id
      addConnector: '/connectors',
      checkConnectorHealth: '/connectors/check/', //:id

      //  API Communication
      listAPICommunicationIncoming: '/communications/incoming',
      listAPICommunicationOutgoing: '/communications/outgoing',
      APICommunicationDetails: '/communications/', //:id

      //  Other
      version: '/version',
      fileDownload: '/files',

      //  Static files
      amberLogo: '/images/amber-logo.png',
      dolphinLogo: '/itpx-cdn/images/leapest-dolphin-xs.png'

    },
    'links': {
      defaultAvatar: 'https://lh3.googleusercontent.com/-XdUIqdMkCWA/AAAAAAAAAAI/AAAAAAAAAAA/4252rscbv5M/photo.jpg'
    }
  };

  constructor(private environmentService: EnvironmentService) {
    this.config = Object.assign(this.config, environmentService.config);
  }

  get(key: any) {
    return this.config[key];
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/config.service.ts